export default __webpack_public_path__ + "static/media/13.82a92df9.mp3";